export class AgGridCommonConstant {
}

export enum GridName {
    SNIPPETLIST = "snippet-list",
    AG_GRID_PAGINATIONMODEL = 'agGridPaginationModel',
    LISTMANAGER = "list-manager",
    LIST_MANAGER_INFO_BYID = "list-manager-info",

}

export enum StorageName {
    LISTMANAGER_SNIPPETLIST_GRID = "LISTMANAGER_SNIPPETLIST_GRID",
    LISTMANAGER_GRID = "LISTMANAGER_GRID",
    LISTMANAGER_INFO_GRID = "LISTMANAGER_INFO_GRID"


}
